import { SalesItemBookingCategoryType } from '@navio/nsdk';

// cspell: disable
export const insuranceCompanies: { value: string; label: string }[] = [
  { value: 'alfa-forsikring', label: 'Alfa Forsikring' },
  { value: 'aspida-forsikring', label: 'Aspida Forsikring' },
  { value: 'balder-forsikring', label: 'Balder Forsikring' },
  { value: 'byggmesterforsikring', label: 'Byggmesterforsikring' },
  { value: 'codan-forsikring', label: 'Codan Forsikring' },
  { value: 'coverme', label: 'CoverMe' },
  { value: 'digisure', label: 'Digisure' },
  { value: 'eika-forsikring', label: 'Eika Forsikring' },
  { value: 'eir-forsakring-ab', label: 'Eir Försäkring AB' },
  { value: 'enter-forsikring', label: 'Enter Forsikring' },
  { value: 'euro-insurances-ayvens', label: 'Euro Insurances (Ayvens)' },
  { value: 'fair-insurance', label: 'FAIR INSURANCE' },
  { value: 'foreign-vehicle', label: 'Foreign vehicle' },
  { value: 'fremtind-sb1-dnb', label: 'Fremtind (SB1 og DNB)' },
  { value: 'frende-forsikring', label: 'Frende Forsikring' },
  { value: 'gjensidige-forsikring', label: 'Gjensidige Forsikring' },
  { value: 'granne-forsikring', label: 'Granne Forsikring' },
  { value: 'greenval-insurance-dac-arval', label: 'Greenval Insurance DAC (Arval)' },
  { value: 'hdi-gerling', label: 'HDI Gerling' },
  { value: 'if-skadeforsikring', label: 'IF Skadeforsikring' },
  { value: 'jbf-bank-forsikring', label: 'JBF Bank og Forsikring' },
  { value: 'klp-skadeforsikring', label: 'KLP Skadeforsikring' },
  { value: 'knif-trygghet-forsikring', label: 'Knif Trygghet Forsikring' },
  { value: 'landkreditt-forsikring', label: 'Landkreditt Forsikring' },
  { value: 'ly-forsikring', label: 'LY Forsikring' },
  { value: 'motorinsuranceonly', label: 'MotorInsuranceOnly' },
  { value: 'protector', label: 'Protector' },
  { value: 'storebrand-skadeforsikring', label: 'Storebrand Skadeforsikring' },
  { value: 'sum-it', label: 'Sum-IT' },
  { value: 'tide-forsikring', label: 'Tide Forsikring' },
  { value: 'tryg-forsikring', label: 'Tryg Forsikring' },
  { value: 'tt-forsikring', label: 'TT Forsikring' },
  { value: 'ukjent-forsikringsselskap', label: 'Ukjent forsikringsselskap' },
  { value: 'van-ameyde-forsikring', label: 'Van Ameyde Forsikring' },
  { value: 'volvia-forsikring', label: 'Volvia Forsikring' },
  { value: 'watercircles', label: 'WaterCircles' },
  { value: 'zurich-insurance', label: 'Zurich Insurance' }
];
// cspell: enable

export const getInsuranceCompanyName = (insuranceCompany: string | undefined | null) => {
  if (!insuranceCompany) {
    return undefined;
  }
  return insuranceCompanies.find((company) => company.value === insuranceCompany)?.label;
};

/**
 * Determines if insurance information is required for a booking based on selected sales items.
 * Insurance information is required when any sales item has the 'stone_chip_repair' category slug.
 *
 * @param salesItemsCars - Array of selected sales items for cars
 * @returns true if insurance information is required, false otherwise
 *
 * @example
 * ```typescript
 * const requiresInsurance = requiresInsuranceInfo(selectedSalesItems);
 * if (requiresInsurance) {
 *   // Navigate to insurance info step
 * } else {
 *   // Navigate to summary step
 * }
 * ```
 */
export const requiresInsuranceInfo = (
  salesItemsCars: Array<{ bookingCategoryType: SalesItemBookingCategoryType | null }>
): boolean => {
  // Check if any sales item is stone chip repair
  return salesItemsCars.some(
    (salesItemCar) => salesItemCar.bookingCategoryType === SalesItemBookingCategoryType.STONE_CHIP_REPAIR
  );
};
